import { create } from 'zustand'

import { get as apiGet } from '@/api/request'
import type { EventInfo } from '@/types/api'

interface EventsStore {
  events: EventInfo[]
  isLoading: boolean
  error: string | null
  _initialized: boolean
  fetch: () => Promise<void>
  reset: () => void
}

export const useEventsStore = create<EventsStore>((set, get) => ({
  events: [],
  isLoading: false,
  error: null,
  _initialized: false,

  async fetch() {
    if (!get()._initialized) {
      set({ isLoading: true, error: null })
    }
    try {
      const res = await apiGet<{ events: EventInfo[] }>('/events')
      if (res.data?.data) {
        set({ events: res.data.data.events, error: null })
      }
    } catch (err) {
      if (!get()._initialized) {
        set({ error: err instanceof Error ? err.message : 'Failed' })
      }
    } finally {
      set({ isLoading: false, _initialized: true })
    }
  },

  reset() {
    set({ events: [], isLoading: false, error: null, _initialized: false })
  },
}))
